import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const ProjectionBuildLoadingState = () => (
  <Stack
    role="status"
    align="center"
    justify="center"
    gap={4}
    className="min-h-0 w-full flex-1 px-6 py-16 text-center"
  >
    <Spinner layout="centered" className="h-auto" />
    <Text variant="caption" tone="muted">
      We're crunching the numbers. Your PayPacks will appear when they're ready.
      This may take a few seconds.
    </Text>
  </Stack>
);
